import { RowReorderIndicator } from './drop-indicator.js';
import { RowReorderGhost } from './reorder-ghost.js';

export function rowReorderEffects(): void {
  customElements.define('dv-row-reorder-ghost', RowReorderGhost);
  customElements.define('dv-row-reorder-indicator', RowReorderIndicator);
}
